// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2rtfx","content":"styles_content__1nSws"};